import { render, staticRenderFns } from "./ProspectiveProjects.vue?vue&type=template&id=609cde35"
import script from "./ProspectiveProjects.vue?vue&type=script&lang=js"
export * from "./ProspectiveProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports